import { Anchor, ModalProps, List, CopyButton } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { DefaultModal } from "../../../../../-components/default-modal"

interface Props extends ModalProps {
  url: string
}

export function AddToGoogleCalendarModal({ url, ...props }: Props) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultModal
      title={t("Calendar_Subscriprions_GoogleManual_Title")}
      {...props}
    >
      <List type="ordered">
        <List.Item>
          <CopyButton value={url}>
            {({ copied, copy }) => (
              <Anchor
                href={url}
                c={copied ? "teal" : "blue"}
                onClick={(e) => {
                  e.preventDefault()
                  copy()
                }}
                style={{ cursor: "pointer" }}
              >
                {copied
                  ? t("CopiedURL")
                  : t("Calendar_Subscriprions_GoogleManual_ClickHereToCopyURL")}
              </Anchor>
            )}
          </CopyButton>
        </List.Item>
        <List.Item>
          <Anchor
            href="https://calendar.google.com/calendar/u/0/r/settings/addbyurl"
            target="_blank"
          >
            {t("Calendar_Subscriprions_GoogleManual_OpenGoogleCalendar")}
          </Anchor>
        </List.Item>
        <List.Item>{t("Calendar_Subscriprions_GoogleManual_Paste")}</List.Item>
        <List.Item>{t("Calendar_Subscriprions_GoogleManual_Add")}</List.Item>
      </List>
    </DefaultModal>
  )
}
